/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EntityType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Adjustment from './Adjustment/index'
import Charge from './Charge/index'
import Correction from './Correction/index'
import General from './General/index'
import No from './No/index'
import Payment from './Payment/index'
import React from 'react'
import Refund from './Refund/index'
import Transfer from './Transfer/index'



/** @type {import('Simple/types.js').View} */
export default function EntityType({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Notes/FilterBy/EntityType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entityTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'entity_type',
path: 'id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: entityTypeIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payment'}>
<Payment
  viewPath={`${viewPath}/Payment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Charge'}>
<Charge
  viewPath={`${viewPath}/Charge`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Refund'}>
<Refund
  viewPath={`${viewPath}/Refund`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Correction'}>
<Correction
  viewPath={`${viewPath}/Correction`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Adjustment'}>
<Adjustment
  viewPath={`${viewPath}/Adjustment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Transfer'}>
<Transfer
  viewPath={`${viewPath}/Transfer`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'General'}>
<General
  viewPath={`${viewPath}/General`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}